import './Banner.css';
function Banner() {
    return (
      <>
        <div className="banner">
          <img src="/Images/Rectangle 426.png" alt="Rectangle 426" />
        </div>
      </>
    );
  }
  function Banner1() {
    return (
      <>
        <div className="banner">
          <img src="/Images/bannertop.webp" alt="top" />
        </div>
      </>
    );
  }
  
  export {Banner ,Banner1};
  /* /Images/Rectangle 426.png */